export const EN = {
    Interno:{
        Principal:"Welcome",
        CerrarSesion:"Logout",
        Menu:{
            OrdenCompra:"Purchase Order",
            SolCambioCuenta:"Bank Account Change",
            Trabajadores:"Workers",
            Admin:"Admin",
            istracion:"istration",
            InvitacionProveedores:"Invitation to suppliers"
        },
        OCDocPendiente:{
            Titulo:"Purchase Order",
            ComoCargo:"How do I submit my invoice?",
            BuscarOC:"Search purchase order not found",
            OC:"PO",
            Contrato:"Contract",
            FechaOC:"PO Date",
            PorEnviar:"Pending",
            Certificados:"Certificates",
            Soportes:"Support",
            Facturas:"Invoices",
            Accion:"Action",
            RFCRecept:"RFC Recept.:",
            Moneda:"Currency",
            FechaReqSitio:"Required on Site",
            Subtotal:"Subtotal",
            Comprador:"Buyer",
            Impuestos:"Taxes",
            Activador:"Activator",
            Retenidos:"Retained",
            Total:"Total",
            HeaderFacturasTutorial:"How do I submit my invoice?",
            Tutorial_Paso1Titulo:"1.- Purchase Orders",
            Tutorial_Paso1Desc:'Find the purchase order and select the "Invoices" option in the action column dropdown menu',
            Tutorial_Paso2Titulo:"2.- Selecting a line item",
            Tutorial_Paso2Desc:"Upload the invoice for the applicable line item.",
            Tutorial_Paso3Titulo:"3.- Invoice upload",
            Tutorial_Step1:"Select the entries to calculate the invoice amount (In case of Material Receipt).",
            Tutorial_Step2:"Upload the .xml file (Only applicable for Mexican suppliers).",
            Tutorial_Step3:"Upload the .pdf file.",
            Tutorial_Step4:"Review the invoice amounts.",
            Tutorial_Step5:"Press the Send button.",
            Tutorial_BtnVideo:"Watch video tutorial",
            Tutorial_BtnCerrar:"Close",
            HeaderBuscarOC:"Purchase Order Search",
            BuscarOCInstruccion:"Enter the purchase order to see the reason why it is not displayed in the list.",
            BuscarOCLabel:"Purchase Order:",
            BuscarOCBtn:"Search",
            Concepto:"Concept",
            MontoConImpuestos:"Amount with<br>taxes",
            TotalRemision:"Total<br>Remittance",
            Facturado:"Invoiced",
            PorFacturar:"Pending Invoice",
            Factura:"Invoice",
            Subir:"Upload"
        },
        EnvioFacturas:{
            Titulo:"Invoice Submission",
            OrdenCompra:"Purchase Order",
            Moneda:"Currency",
            FechaReqSitio:"Required date on site",
            Subtotal:"Subtotal",
            Comprador:"Buyer",
            Impuestos:"Taxes",
            Total:"Total",
            Concepto:"Concept",
            Monto:"Amount",
            Facturado:"Invoiced",
            PorFacturar:"Pending Invoice",
            Factura:"Invoice",
            TotalesConImpuesto:"Totals With Tax",
            Subir:"Upload",
            ArchivoXML:"XML File",
            ArchivoPDF:"PDF File",
            NumFactura:"Invoice No.",
            Impuesto:"Tax",
            FechaFactura:"Invoice Date",
            TotalFactura:"Invoice Total",
            Referencia:"Reference",
            Comentarios:"Comments",
            BtnCancelar:"Cancel",
            BtnEnviar:"Submit"
        },
        CambioCuentaBancaria:{
            Titulo:"Bank Account Change Request",
            Motivo:"Reason for bank account change:",
            MotivoPH:"Reason",
            ModalAvisoP1:"The account change request requires sending the requested documentation and will be sent to Arendal for approval.",
            ModalAvisoP2:"We will contact the company's legal representative to verify the information.",
            BtnProceder:"Proceed",
            ModalEnProcesoTitulo:"Request in progress",
            ModalEnProceso:"There is already a bank account change request this month, please wait for a response.",
            BtnRegresar:"Back",
            Reemplazar:"Replace"
        },
        InvitacionProveedores:{
            Titulo:"Supplier Invitation",
            Estatus:"Status",
            VerSoloBtnText:"View only my invitations",
            BtnInvitar:"Invite",
            FechaInvitacion:"Invitation Date",
            FechaEstatus:"Status Date",
            Proveedor:"Supplier",
            Contacto:"Contact",
            CorreoContacto:"Contact Email",
            InvitadoPor:"Invited by",
            ColEnviar:"Send",
            ColCancelar:"Cancel",
            ModalTitulo:"Invite supplier",
            TipoProveedor:"Supplier Type",
            TipoPersona:"Person Type",
            SolicitarSubcontratos:"Request additional subcontract documentation.",
            Proyecto:"Project",
            Pais:"Country",
            RazonSocial:"Company Name",
            RazonSocialPH:"Company name",
            NomCom:"Trade Name",
            NomComPH:"Trade Name",
            DiasPlazo:"Deadline Days",
            DiasPlazoHint:"Deadline days",
            ProveedorBuscarPH:"Type 5 characters to search for the supplier...",
            SeccionContacto:"Contact",
            Nombres:"Names",
            NombresPH:"Names",
            Apellidos:"Last Names",
            ApPaternoPH:"Last Name",
            ApMaternoPH:"Second Last Name",
            Puesto:"Position",
            PuestoPH:"Position",
            CorreoLabel:"Email",
            CorreoPH:"email@company.com",
            Telefono:"Phone",
            ComentariosInvitacion:"Invitation Comments",
            BtnCancelar:"Cancel",
            BtnEnviarInvitacion:"Send Invitation"
        },
        OrdenCompra:{
            a:""
        },
        Trabajadores:{
            a:""
        }
    },
    Externo:{
        Login:{
            TituloLogin:"Login with registered email",
            CorreoHint:"Mail",
            ContrasenaHint:"Password",
            BtnLogin:"Login",
            RecordarContrasena:"Remember password",
            OlvideContrasena:"Forgot my password",
            BtnRegistro:"Register (I'm already an Arendal supplier)",
            Notify:{
                IntentosExcedidos:"The number of attempts allowed has been exceeded (5), please try again in at least one minute.",
                TerminoTiempoEspera:"Timeout has expired, please try again.",
                NecesarioCorreoContrasena:"You need to enter email and password."
            }
        },
        RegistroProveedor:{
            msgProveedorRegistrado:"The provider's data has already been registered.",
            msgInvitacionNoEncontrada:"The invitation was not found or has been deleted.",
            Titulo:"Supplier's information",
            TituloRegistrado:"Data registered successfully.",
            msgTituloRegistrado:"The data was registered successfully, please wait for the registration authorization, you can close this window.",
            PaisOrigen:"Country",
            RFCTAX:"RFC / Tax ID",
            NomComercial:"Commercial name",
            NomComercialHint:"Comercial name",
            RazonSocial:"Company Name",
            RazonSocialHint:"Company Name",
            TipoEmpresa:"Type of company",
            PersonaMoral:"Company",
            PersonaFisica:"Person",
            DiasPlazo:"Deadline days",
            ContactoArendal:"Contact in Arendal",
            ContactoArendalHint:"Purchasing Group",
            //?Documentacion
                tabDocumentacion:"Documentation",
                tabDireccion:"Address",
                tabDatosContacto:"Contact Data",
                tabCuentaBancaria:"Bank Account",
                tbDocumento:"Document",
                tbDescripcion:"Description",
                tbArchivo:"File (PDF/JPG/PNG/DOC/DOCX)",
                tbSubir:"Upload",
            //?Direccion
                CalleNumero:"Street and number",
                CalleNumeroHint:"Street and number",
                Colonia:"Adress",
                ColoniaHint:"Adress",
                CP:"Postal C.",
                CPHint:"Postal code.",
                Ciudad:"City",
                CiudadHint:"City",
                Estado:"Cown",
                EstadoHint:"Cown",
            //?Contacto
                Nombres:"Name",
                NombresHint:"Name",
                PaternoHint:"Last name",
                MaternoHint:"Second last name",
                Puesto:"Position",
                PuestoHint:"Position",
                Correo:"E-mail",
                CorreoHint:"E-mail",
                Telefono:"Telephone",
                TelefonoHint:"Telephone",
                Direccion:"Address",
                DireccionHint:"Address",
            //?Banco
                Moneda:"Currency",
                Banco:"Bank",
                BancoHint:"Bank",
                NumCuenta:"Account number",
                NumCuentaHint:"Account number",
                Titular:"Account Holder",
                TitularHint:"Account holder",
                ABA:"ABA",
                ABAHint:"ABA",
                SwiftCode:"SwiftCode",
                SwiftCodeHint:"SwiftCode",
            //?Boton Guardar
                BtnGuardarEnviar:"Save and Send",
            //?Notificaciones
                Notify:{
                    ExtencionIncorrecta:"Please select a pdf, jpg, png, doc, docx file.",
                    ArchivoExistente:"There is already a file that was selected previously, please select another one.",
                //?Validaciones Guardado
                    ValidacionSwiftCode:"Please enter the swift code.",
                    ValidacionABA:"Please enter the ABA.",
                    ValidacionTitular:"Please enter the account holder.",
                    ValidacionNoCuenta:"Please enter the account number.",
                    ValidacionBanco:"Please enter the bank.",
                    ValidacionMoneda:"Please enter the currency.",
                    ValidacionDireccion:"Please enter the contact's address.",
                    ValidacionTelefono:"Please enter the contact's phone number.",
                    ValidacionCorreo:"Contact email not found please contact the administrator.",
                    ValidacionPuesto:"Please enter the contact's title.",
                    ValidacionApellidoM:"Please enter the contact's maternal surname.",
                    ValidacionApellidoP:"Please enter the contact's last name.",
                    ValidacionNombres:"Please enter the name(s) of the contact.",
                    ValidacionEstado:"Please enter the state.",
                    ValidacionCiudad:"Please enter the city.",
                    ValidacionCP:"Please enter zip code.",
                    ValidacionColonia:"Please introduce the colony.",
                    ValidacionCalleNumero:"Please enter the street and number.",
                    ValidacionDiasPlazo:"Please enter the deadline days.",
                    ValidacionRazonSocial:"Please enter the company name.",
                    ValidacionNomComercial:"Please enter the business name.",
                    ValidacionRFC:"Please enter RFC / Tax ID.",
                    ValidacionPais:"Please select the country.",
                    ValidacionDocumentos:"Please upload the missing documents.",
                //?Error peticion
                    ErrorPeticion:"An unexpected error occurred, contact the administrator.",
                //?Error Token
                    ErrorToken:"Sorry, no valid token found."
                }
        }
    }
};
